<template>
  <div class="wrapper">
    <HTMLHeader></HTMLHeader>

    <section class="mainpage">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <h3>
              Üdvözöljük
              <span>Köszöntjük a Széchenyi István Egyetem rendszerében</span>
            </h3>
          </div>
          <div class="col-sm-6">
            <p>A Kiválósági Támogatási Rendszer a különböző egyetemi szervezetek által kezelt ösztöndíj-pályázatok és támogatási lehetőségek közös felületen való elérését biztosítja.</p>
          </div>
          <div v-if="this.$root.user == ''" class="col-sm-offset-1 col-sm-5">
            <h4>Bejelentkezés</h4>
            <p>Az oldalra az uni.sze.hu oldalon érvényes felhasználónevével és jelszavával tud bejelentkezni.</p>
            <a v-on:click="this.$root.openLoginPopup" href="javascript:void(0)" class="button">Belépés</a>
          </div>
          <div v-if="this.$root.user != ''" class="col-sm-offset-1 col-sm-5">
            <h4>Kijelentkezés</h4>
            <a v-on:click="this.$root.logout" href="javascript:void(0)" class="button">Kilépés</a>
          </div>
        </div>
      </div>
    </section>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>
<script>
import Vue from 'vue';
import HTMLHeader from './tpl_header.vue';
import HTMLFooter from './tpl_footer.vue';
import ProfileMenu from './tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {

    }
  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      _this.resizeImage();
      setHeaderDarkLine();
      $(window).resize(function() {
        _this.resizeImage();
        setHeaderDarkLine();
      });
    });
  },
  methods: {
    resizeImage: function() {
      $('.mainpage').css({
        'min-height': $(window).innerHeight() - $('footer').outerHeight() - $('header').outerHeight()
      });
    }
  }
}
</script>




// WEBPACK FOOTER //
// home.vue?4cd87bf6